import {
  SET_MODAL_CONTENT,
  TOGGLE_MODAL,
  FILTER_CATEGORY,
  CHANGE_FILTER_STATE
} from "../actions/type";


export function modalReducer(
  state = {
    isOpenned: false,
    content: {
      title: "TONY ZANDER",
      position: "VP, PRODUCT",
      categories: ["Category 1", "Category 2"],
      img: "",
      wide: false,
      linkedin: "",
      facebook: "",
      twitter: "",
      text:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi."
    }
  },
  action
) {
  switch (action.type) {
    case SET_MODAL_CONTENT:
      return { ...state, content: action.content };
    case TOGGLE_MODAL:
      return { ...state, isOpenned: action.isOpenned };
    default:
      return state;
  }
}

export function filterReducer(state = { toFilter: "all", state: "" }, action) {
  switch (action.type) {
    case FILTER_CATEGORY:
      return { ...state, toFilter: action.category };
    case CHANGE_FILTER_STATE:
      return { ...state, state: action.state };
    default:
      return state;
  }
}
